import { render } from "./ExchangeManagement.vue?vue&type=template&id=a78f7e1c&scoped=true"
import script from "./ExchangeManagement.vue?vue&type=script&lang=js"
export * from "./ExchangeManagement.vue?vue&type=script&lang=js"

import "./ExchangeManagement.vue?vue&type=style&index=0&id=a78f7e1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78f7e1c"]])

export default __exports__